export interface IPaymentStrings {
    discount: string;
    frequency: {
        annual: string;
        monthly: string;
        semmiannual: string;
    };
    inputMask: string;
    identification_number_label: string;
    payment_options: {
        bank_slip: {
            description: string;
            form: {
                title: string;
                email_label: string;
                identification_number_label: string;
                phone_label: string;
                button: string;
            }
        };
        credit_card: {
            description: string;
            form: {
                title: string;
                button: string;
            };
        };
        pix: {
            description: string;
            form: {
                title: string;
                button: string;
            };
        };
    };
    payment_order: {
        forward_payment_until: string;
        title: string;
        strategy_buttons: {
            create_bank_slip_button_label: string;
            cancel_bank_slip_confirmation: string;
            send_bank_slip_button_label: string;
            cancel_bank_slip_button_label: string;
            payment_bank_slip_button_label: string;
            due_date_input_label: string;
            our_number_input_label: string;
            barcode_input_label: string;
            modal: {
                button_cancel: string;
                button_forward: string;
            }
        };
        errors: {
            PAYMENT_ORDER_DUPLICATE: string;
            PAYMENT_ORDER_AMOUNT_EXCEED: string;
            PAYMENT_ORDER_FAILED: string;
        };
        success: {
            PAYMENT_ORDER_SUCCESS: string;
        }
    };
    title: string;
}

export const PaymentStrings: {
    PTBR: IPaymentStrings
} = {
    PTBR: {
        discount: "% de Desconto",
        frequency: {
            annual: "Ano",
            monthly: "Mês",
            semmiannual: "Semestre",
        },
        inputMask: "(99) 9-9999-9999",
        identification_number_label: "999.999.999-99",
        payment_options: {
            bank_slip: {
                description: "Boleto",
                form: {
                    title: "Pagamento por boleto bancário",
                    identification_number_label: "CPF/CNPJ (Apenas números)",
                    email_label: "Informe seu e-mail para cadastro no plano",
                    phone_label: "Seu telefone",
                    button: "Assinar"
                },
            },
            credit_card: {
                description: "Cartão de Crédito",
                form: {
                    title: "Pagamento por cartão de crédito",
                    button: "Assinar"
                },
            },
            pix: {
                description: "Pix",
                form: {
                    title: "Pagamento via Pix",
                    button: "Assinar",
                },
            },
        },
        payment_order: {
            title: "Assinaturas - Controle de Financeiro",
            forward_payment_until: "Data limite",
            strategy_buttons: {
                create_bank_slip_button_label: "Gerar Boleto",
                cancel_bank_slip_confirmation: "Esta ação é irreversível. Tem certeza que deseja cancelar este boleto?",
                send_bank_slip_button_label: "Enviar",
                cancel_bank_slip_button_label: "Cancelar",
                payment_bank_slip_button_label: "Quitar",
                due_date_input_label: "Data de vencimento",
                our_number_input_label: "Nosso Número",
                barcode_input_label: "Código de Barras",
                modal: {
                    button_cancel: "Cancelar",
                    button_forward: "Registrar",
                },
            },
            errors: {
                PAYMENT_ORDER_DUPLICATE: "Você já utilizou esta referência NOSSO NÚMERO ou CÓDIGO DE BARRAS.",
                PAYMENT_ORDER_AMOUNT_EXCEED: "Você não pode registrar um boleto neste valor para esta ordem de pagamento.",
                PAYMENT_ORDER_FAILED: "Falha ao registrar o boleto"
            },
            success: {
                PAYMENT_ORDER_SUCCESS: "Boleto registrado com sucesso!",
            }
        },
        title: "Plano",
    },
};